import React from 'react';

import { SigningInSpinner } from '../authentication/components/loginSpace/SigningInSpinner';
import { PKCECodeChallenge, PKCEStore } from './PKCEStore';
import { PKCEUrls } from './PKCEUrls';

export interface GenerateCodeChallengeProps {
  readonly appUriProtocol: string;
}

export const GenerateCodeChallenge: React.FunctionComponent<GenerateCodeChallengeProps> = props => {
  React.useEffect(
    () => {
      let didCancel = false;
      PKCEStore.generateCodeChallenge()
        .then(codeChallenge => !didCancel && redirectToGetAuthorizationCode(codeChallenge, props.appUriProtocol));
      return () => didCancel = true;
    },
    // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return <SigningInSpinner/>;
};

function redirectToGetAuthorizationCode(codeChallenge: PKCECodeChallenge, appUriProtocol: string): void {
  window.location.href = PKCEUrls.getAuthorizationCodeUrl(true,  {
    appUriProtocol,
    codeChallenge: codeChallenge.codeChallenge,
    codeChallengeMethod: codeChallenge.codeChallengeMethod,
  });
}
